import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AirportNavaid, NavaidType } from '../models/airport-navaid.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { LatLon } from '../../util/geodesy/latlon';
import { NavaidService } from '../service/navaid.service';
var EditNavaidComponent = /** @class */ (function () {
    function EditNavaidComponent(_matDialogRef, _snackBar, data, _navaidService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._navaidService = _navaidService;
        this.isNew = false;
        this.isLoading = true;
        this.navaid = data.navaid || new AirportNavaid();
        this.isNew = data.isNew || false;
        this.airportId = data.airportId;
        this.origNavaid = Object.assign(new AirportNavaid(), data.navaid);
        if (this.navaid.location != null) {
            this.latitude = this.navaid.location.lat;
            this.longitude = this.navaid.location.lon;
        }
        else {
            this.latitude = null;
            this.longitude = null;
        }
        if (this.isNew) {
            this.selectedNavaidType = '';
        }
        else {
            this.selectedNavaidType = this.getNavaidType(this.navaid.type);
        }
    }
    EditNavaidComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl(this.navaid.name, [Validators.required, Validators.maxLength(100)]),
            identifier: new FormControl(this.navaid.identifier, [Validators.required, Validators.maxLength(6)]),
            type: new FormControl(this.selectedNavaidType, [Validators.required]),
            frequency: new FormControl(this.navaid.frequency, [Validators.required, Validators.pattern('^-?\\d{0,6}\\.?\\d{0,3}$')]),
            latitude: new FormControl(this.latitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')]),
            longitude: new FormControl(this.longitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')])
        });
        this.isLoading = false;
    };
    EditNavaidComponent.prototype.getNavaidType = function (type) {
        switch (type) {
            case NavaidType.DME:
                return 'DME';
            case NavaidType.MarineNDB:
                return 'Marine NDB';
            case NavaidType.NDB:
                return 'NDB';
            case NavaidType.NDB_DME:
                return 'NDB_DME';
            case NavaidType.TACAN:
                return 'TACAN';
            case NavaidType.VOR:
                return 'VOR';
            case NavaidType.VOR_DME:
                return 'VOR_DME';
            case NavaidType.VORTAC:
                return 'VORTAC';
            case NavaidType.VOT:
                return 'VOT';
            default:
                return '';
        }
    };
    EditNavaidComponent.prototype.setNavaidType = function (type) {
        switch (type) {
            case 'DME':
                return NavaidType.DME;
            case 'Marine NDB':
                return NavaidType.MarineNDB;
            case 'NDB':
                return NavaidType.NDB;
            case 'NDB_DME':
                return NavaidType.NDB_DME;
            case 'TACAN':
                return NavaidType.TACAN;
            case 'VOR':
                return NavaidType.VOR;
            case 'VOR_DME':
                return NavaidType.VOR_DME;
            case 'VORTAC':
                return NavaidType.VORTAC;
            case 'VOT':
                return NavaidType.VOT;
        }
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditNavaidComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        this.navaid.name = this.formGroup.value.name;
                        this.navaid.identifier = this.formGroup.value.identifier;
                        this.navaid.type = this.setNavaidType(this.formGroup.value.type);
                        this.navaid.frequency = this.formGroup.value.frequency;
                        this.navaid.location = new LatLon(this.formGroup.value.latitude, this.formGroup.value.longitude);
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._navaidService.postNavaid(this.navaid)];
                    case 1:
                        result = _a.sent();
                        this.navaid = AirportNavaid.parse({ navaid: result });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._navaidService.putNavaid(this.navaid)];
                    case 3:
                        result = _a.sent();
                        this.navaid = AirportNavaid.parse({ navaid: result });
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, navaid: this.navaid });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditNavaidComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditNavaidComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.navaid, this.origNavaid);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditNavaidComponent;
}());
export { EditNavaidComponent };
